/**
 * Used to get a solid colour that has the same look as if it was transparent
 * on a white background.
 *
 * https://graphicdesign.stackexchange.com/a/113050
 */
const bgColour = 255;
const getOpacityEquivalentForColour = (colour, opacity) => {
  return bgColour - opacity * (255 - colour);
};

export const getOpacityEquivalent = (r, g, b, a) => {
  return [
    getOpacityEquivalentForColour(r, a),
    getOpacityEquivalentForColour(g, a),
    getOpacityEquivalentForColour(b, a),
  ];
};

/**
 * Get black or white depending on the colour given to give the text the best
 * chance of being readable.
 *
 * https://stackoverflow.com/a/3943023
 */
const weighting = 149;
const redWeighting = 0.299;
const greenWeighting = 0.587;
const blueWeighting = 0.114;
export const getBestTextColourForColour = (red, green, blue) => {
  if (
    red * redWeighting + green * greenWeighting + blue * blueWeighting >
    weighting
  ) {
    return [0, 0, 0];
  } else {
    return [255, 255, 255];
  }
};

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : [255, 255, 255];
};
